export class GenericEvent {
    code?: string;
    description?: string;
}